import * as z from "zod/v4";

/**
 * Schema for generating a rescue discount code.
 * Used when displaying the rescue modal/panel to potentially abandoning customers.
 * The backend will look up the team's rescue panel settings to determine the discount amount.
 */
export const generateRescueDiscountCode = {
  name: "generateRescueDiscountCode" as const,
  input: z.null(),
  output: z.object({
    discountCode: z.string(),
  }),
};
